/**
 * Wolf Forty Designs — Theme JS
 * Drop Culture Features: Countdown · AJAX Cart · Toast · Size Selector · Notify Modal
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================
     MOBILE MENU
  ============================================ */
  const ham = document.getElementById('ham');
  const menu = document.getElementById('mob-menu');
  const closeBtn = document.getElementById('mob-close');
  if (ham && menu && closeBtn) {
    ham.addEventListener('click', () => { menu.classList.add('open'); ham.classList.add('open'); document.body.style.overflow = 'hidden'; });
    closeBtn.addEventListener('click', closeMenu);
    menu.querySelectorAll('.mob-links a').forEach(a => a.addEventListener('click', closeMenu));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
    function closeMenu() { menu.classList.remove('open'); ham.classList.remove('open'); document.body.style.overflow = ''; }
  }

  /* ============================================
     SCROLL REVEAL
  ============================================ */
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); } });
  }, { threshold: .08, rootMargin: '0px 0px -20px 0px' });
  document.querySelectorAll('.reveal').forEach(el => {
    // If element is already in the viewport on load, show it immediately
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('vis');
    } else {
      obs.observe(el);
    }
  });

  /* ============================================
     CART COUNT
  ============================================ */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-pill').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(() => {});
  }
  refreshCartCount();

  /* ============================================
     TOAST NOTIFICATION
  ============================================ */
  function showToast(msg, type) {
    const old = document.getElementById('wfd-toast');
    if (old) old.remove();
    const toast = document.createElement('div');
    toast.id = 'wfd-toast';
    toast.className = 'wfd-toast' + (type === 'error' ? ' wfd-toast--error' : '');
    toast.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">' +
      (type === 'error'
        ? '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>'
        : '<polyline points="20 6 9 17 4 12"/>') +
      '</svg><span>' + msg + '</span>';
    document.body.appendChild(toast);
    requestAnimationFrame(() => requestAnimationFrame(() => toast.classList.add('wfd-toast--visible')));
    setTimeout(() => { toast.classList.remove('wfd-toast--visible'); setTimeout(() => toast.remove(), 350); }, 3000);
  }
  window.showToast = showToast;

  /* ============================================
     AJAX ADD TO CART
  ============================================ */
  function addToCart(variantId, quantity, btnEl) {
    if (!variantId) { showToast('Please select a size', 'error'); return; }
    quantity = quantity || 1;
    if (btnEl) { btnEl.classList.add('dz-loading'); btnEl._orig = btnEl.textContent; btnEl.textContent = 'Adding\u2026'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
    })
      .then(r => r.json())
      .then(data => {
        if (data.status) { showToast(data.description || 'Could not add to cart', 'error'); }
        else { showToast('Added to cart'); refreshCartCount(); }
      })
      .catch(() => showToast('Network error \u2014 try again', 'error'))
      .finally(() => { if (btnEl) { btnEl.classList.remove('dz-loading'); btnEl.textContent = btnEl._orig || 'Add to Cart'; } });
  }
  window.addToCart = addToCart;

  /* ============================================
     DROP ZONE — KNIFE ONE-CLICK
  ============================================ */
  document.querySelectorAll('.dz-atc-btn--knife').forEach(btn => {
    btn.addEventListener('click', () => addToCart(btn.dataset.variant, 1, btn));
  });

  /* ============================================
     DROP ZONE — APPAREL SIZE SELECTOR
  ============================================ */
  document.querySelectorAll('.dz-size-btn').forEach(sizeBtn => {
    sizeBtn.addEventListener('click', () => {
      const productId = sizeBtn.dataset.product;
      document.querySelectorAll('.dz-size-btn[data-product="' + productId + '"]').forEach(b => b.classList.remove('dz-size-btn--active'));
      sizeBtn.classList.add('dz-size-btn--active');
      const atcBtn = document.querySelector('.dz-atc-btn--apparel[data-product="' + productId + '"]');
      if (atcBtn) {
        atcBtn.dataset.variant = sizeBtn.dataset.variant;
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart \u2014 ' + sizeBtn.dataset.size;
      }
    });
  });

  document.querySelectorAll('.dz-atc-btn--apparel').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!btn.dataset.variant) { showToast('Please select a size', 'error'); return; }
      addToCart(btn.dataset.variant, 1, btn);
    });
  });

  /* ============================================
     PRODUCT PAGE — AJAX FORM
  ============================================ */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = productForm.querySelector('[name="id"]').value;
      const qty = parseInt((productForm.querySelector('[name="quantity"]') || {}).value || '1');
      const atcBtn = productForm.querySelector('.atc-btn');
      addToCart(variantId, qty, atcBtn);
    });
  }

  /* ============================================
     PRODUCT PAGE — SIZE BUTTON VARIANT SELECTOR
  ============================================ */
  const variantData = JSON.parse((document.getElementById('variant-data') || {}).textContent || '[]');
  const priceDisplay = document.getElementById('variant-price');
  const mainAtcBtn = document.querySelector('.atc-btn');

  document.querySelectorAll('.pp-size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.pp-size-btn').forEach(b => b.classList.remove('pp-size-btn--active'));
      btn.classList.add('pp-size-btn--active');
      const hidden = document.getElementById('selected-variant');
      if (hidden) hidden.value = btn.dataset.variant;
      const variant = variantData.find(v => v.id === parseInt(btn.dataset.variant));
      if (variant) {
        if (priceDisplay) priceDisplay.textContent = formatMoney(variant.price);
        if (mainAtcBtn) { mainAtcBtn.disabled = !variant.available; mainAtcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out'; }
      }
    });
  });

  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ============================================
     COUNTDOWN TIMER
  ============================================ */
  const cdEl = document.getElementById('dz-countdown');
  if (cdEl && cdEl.dataset.target) {
    const target = new Date(cdEl.dataset.target).getTime();
    let fired = false;
    function pad(n) { return String(n).padStart(2, '0'); }
    function onCountdownEnd() {
      if (fired) return;
      fired = true;
      /* Zero out the digits */
      ['dz-days','dz-hrs','dz-mins','dz-secs'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.textContent = '00';
      });
      /* Flip the drop zone section visually to a "live" state */
      const section = document.getElementById('drop-zone');
      if (section) {
        /* Swap CSS classes */
        section.classList.remove('dz--coming-soon');
        section.classList.add('dz--live');
        /* Swap the status pill */
        const pill = section.querySelector('.dz-status-pill');
        if (pill) {
          pill.classList.add('dz-status-pill--live');
          pill.innerHTML = '<span class="dz-live-dot"></span>Drop Live Now';
        }
        /* Hide the countdown + notify button, show a live CTA */
        const cdWrap = section.querySelector('.dz-countdown');
        if (cdWrap) cdWrap.style.display = 'none';
        const notifyBtn = document.getElementById('dz-notify-trigger');
        if (notifyBtn) notifyBtn.style.display = 'none';
        /* Insert a live banner + reload prompt */
        const heroBottom = section.querySelector('.dz-hero-bottom');
        if (heroBottom) {
          const liveMsg = document.createElement('div');
          liveMsg.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:14px;';
          liveMsg.innerHTML =
            '<p style="font-family:var(--cond);font-size:.7rem;letter-spacing:.18em;text-transform:uppercase;color:var(--muted);margin:0;">The drop is live — refresh to shop</p>' +
            '<button onclick="location.reload()" style="font-family:var(--cond);font-size:.66rem;font-weight:600;letter-spacing:.18em;text-transform:uppercase;padding:13px 32px;background:var(--ink);color:var(--bg);border:none;cursor:pointer;">Shop Now &rarr;</button>';
          heroBottom.appendChild(liveMsg);
        }
      }
      /* Sticky top banner */
      if (!document.getElementById('wolf-live-banner')) {
        const banner = document.createElement('div');
        banner.id = 'wolf-live-banner';
        banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:9999;background:var(--ink);color:var(--bg);font-family:var(--cond);font-size:.64rem;letter-spacing:.2em;text-transform:uppercase;text-align:center;padding:12px 16px;display:flex;align-items:center;justify-content:center;gap:12px;';
        banner.innerHTML = '<span style="width:7px;height:7px;border-radius:50%;background:#e85d4a;display:inline-block;animation:livePulse 1.2s ease-in-out infinite;flex-shrink:0;"></span>' +
          'Drop is live — <button onclick="location.reload()" style="background:none;border:none;color:inherit;font:inherit;letter-spacing:inherit;text-decoration:underline;cursor:pointer;padding:0;">refresh to shop</button>' +
          '<button onclick="this.parentNode.remove()" style="background:none;border:none;color:var(--muted);font-size:1rem;cursor:pointer;line-height:1;margin-left:8px;">✕</button>';
        document.body.prepend(banner);
        /* Inject pulse keyframe if not present */
        if (!document.getElementById('wolf-live-kf')) {
          const kf = document.createElement('style');
          kf.id = 'wolf-live-kf';
          kf.textContent = '@keyframes livePulse{0%,100%{opacity:1}50%{opacity:.3}}';
          document.head.appendChild(kf);
        }
      }
    }
    function tick() {
      const diff = target - Date.now();
      if (diff <= 0) { onCountdownEnd(); return; }
      const el = (id) => document.getElementById(id);
      if (el('dz-days')) el('dz-days').textContent = pad(Math.floor(diff / 86400000));
      if (el('dz-hrs'))  el('dz-hrs').textContent  = pad(Math.floor((diff % 86400000) / 3600000));
      if (el('dz-mins')) el('dz-mins').textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (el('dz-secs')) el('dz-secs').textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ============================================
     NOTIFY ME MODAL — Shopify email + PostScript SMS
  ============================================ */
  const notifyTrigger = document.getElementById('dz-notify-trigger');
  const modalOverlay  = document.getElementById('dz-modal-overlay');
  const modalClose    = document.getElementById('dz-modal-close');
  const notifyForm    = document.getElementById('dz-notify-form');
  const emailInput    = document.getElementById('dz-email-input');
  const phoneInput    = document.getElementById('dz-phone-input');

  // Auto-format phone as user types: (555) 867-5309
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      var digits = this.value.replace(/\D/g, '').slice(0, 10);
      var fmt = '';
      if (digits.length > 0) fmt = '(' + digits.slice(0, 3);
      if (digits.length >= 4) fmt += ') ' + digits.slice(3, 6);
      if (digits.length >= 7) fmt += '-' + digits.slice(6, 10);
      this.value = fmt;
    });
  }

  if (notifyTrigger && modalOverlay) {
    const formState    = document.getElementById('dz-modal-form-state');
    const successState = document.getElementById('dz-modal-success-state');
    const dzSection    = document.getElementById('drop-zone');

    function closeModal() {
      modalOverlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    // After Shopify email submit, page reloads with ?customer_posted=true
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      if (formState)    formState.style.display    = 'none';
      if (successState) successState.style.display = 'block';
      modalOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      history.replaceState(null, '', window.location.pathname + window.location.hash);
      setTimeout(closeModal, 4000);
    }

    // Open modal on button click
    notifyTrigger.addEventListener('click', () => {
      if (formState)    formState.style.display    = 'block';
      if (successState) successState.style.display = 'none';
      modalOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => emailInput && emailInput.focus(), 100);
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', e => { if (e.target === modalOverlay) closeModal(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && modalOverlay.classList.contains('open')) closeModal(); });

    // On form submit: require at least one field, then handle PostScript SMS if phone given.
    if (notifyForm) {
      notifyForm.addEventListener('submit', function (e) {
        var email  = emailInput ? emailInput.value.trim() : '';
        var digits = phoneInput ? phoneInput.value.replace(/\D/g, '') : '';
        var errorEl = document.getElementById('dz-modal-error');

        // Must have at least email or a valid 10-digit phone
        if (!email && digits.length !== 10) {
          e.preventDefault();
          if (errorEl) errorEl.style.display = 'block';
          return;
        }
        if (errorEl) errorEl.style.display = 'none';

        // If phone provided, handle SMS opt-in
        if (digits.length === 10) {
          var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
          if (isMobile) {
            // Mobile: open native SMS app pre-filled with keyword
            var smsHref = 'sms:+18774506793?body=' + encodeURIComponent('GETONTHELIST');
            window.open(smsHref, '_blank');
          } else {
            // Desktop: show static instructions — can't open SMS app
            var smsNote = document.getElementById('dz-sms-desktop-note');
            if (smsNote) {
              smsNote.style.display = 'block';
            }
          }
        }

        // If no email, block the Shopify form submission (nothing to submit)
        if (!email) {
          e.preventDefault();
          if (formState)    formState.style.display    = 'none';
          if (successState) successState.style.display = 'block';
          setTimeout(closeModal, 4000);
        }
        // If email present, form submits to Shopify normally → reloads with ?customer_posted=true
      });
    }
  }

  /* ============================================
     IMAGE GALLERY (product page)
  ============================================ */
  window.swapImg = function (src) {
    const img = document.getElementById('main-img');
    if (!img) return;
    img.style.opacity = '0';
    setTimeout(() => { img.src = src; img.style.opacity = '1'; }, 180);
  };

});

/* ============================================
   QUICK ADD POPUP
   — Uses event delegation so it works on every page
     and for cards rendered at any time (collection,
     evergreen, shop landing, drop zone).
   ============================================ */
(function() {

  // ── DOM refs — overlay lives in theme.liquid, always present ──
  var qaOverlay  = document.getElementById('qa-overlay');
  var qaClose    = document.getElementById('qa-close');
  var qaImg      = document.getElementById('qa-img');
  var qaEyebrow  = document.getElementById('qa-eyebrow');
  var qaTitle    = document.getElementById('qa-title');
  var qaPrice    = document.getElementById('qa-price');
  var qaStatus   = document.getElementById('qa-status');
  var qaOptLabel = document.getElementById('qa-option-label');
  var qaOptions  = document.getElementById('qa-options');
  var qaCheckout = document.getElementById('qa-checkout-btn');
  var qaCart     = document.getElementById('qa-cart-btn');

  if (!qaOverlay) return;

  var selectedVariantId = null;

  // ── Product status label mapping ──
  function getStatusLabel(btn) {
    var status = btn.dataset.productStatus || '';
    if (status === 'coming_soon') return 'Releasing Soon';
    if (status === 'sold_out')    return 'Sold Out';
    if (btn.dataset.tags && btn.dataset.tags.indexOf('ltd') > -1) return 'Limited';
    if (btn.dataset.tags && btn.dataset.tags.indexOf('new') > -1) return 'New Arrival';
    return '';
  }

  function setCtaState(enabled, label) {
    qaCheckout.disabled = !enabled;
    qaCart.disabled     = !enabled;
    qaCheckout.textContent = enabled ? 'Checkout Now'  : (label || 'Select to Checkout');
    qaCart.textContent     = enabled ? 'Add to Cart'   : 'Add to Cart';
  }

  function openQuickAdd(btn) {
    var variants    = [];
    var hasVariants = false;
    selectedVariantId = null;

    try { variants = JSON.parse(btn.dataset.variants || '[]'); } catch(e) {}
    hasVariants = variants.length > 1;

    // ── Populate static fields ──
    qaImg.src   = btn.dataset.productImage || '';
    qaImg.alt   = btn.dataset.productTitle || '';
    qaTitle.textContent = btn.dataset.productTitle || '';
    qaPrice.textContent = btn.dataset.productPrice  || '';

    var statusLabel = getStatusLabel(btn);
    if (qaStatus) {
      qaStatus.textContent = statusLabel;
      qaStatus.className   = 'qa-status' + (statusLabel ? ' qa-status--visible' : '');
    }

    // ── Category eyebrow ──
    qaEyebrow.textContent = btn.dataset.productType || '';

    // ── Variant buttons ──
    qaOptions.innerHTML = '';
    if (hasVariants) {
      qaOptLabel.textContent = 'Select ' + (btn.dataset.optionName || 'Option');
      variants.forEach(function(v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qa-opt-btn' + (!v.available ? ' qa-opt-btn--sold' : '');
        b.textContent = v.title + (!v.available ? ' — Sold Out' : '');
        b.disabled = !v.available;
        b.setAttribute('data-variant-id', v.id);
        b.addEventListener('click', function() {
          qaOptions.querySelectorAll('.qa-opt-btn').forEach(function(x) {
            x.classList.remove('qa-opt-btn--active');
          });
          b.classList.add('qa-opt-btn--active');
          selectedVariantId = v.id;
          qaPrice.textContent = v.price || btn.dataset.productPrice;
          setCtaState(true);
        });
        qaOptions.appendChild(b);
      });
      setCtaState(false, 'Select to Checkout');
    } else {
      qaOptLabel.textContent = '';
      selectedVariantId = variants[0] ? variants[0].id : null;
      var singleAvail = variants[0] ? variants[0].available : false;
      setCtaState(!!selectedVariantId && singleAvail);
      if (!singleAvail) {
        qaCart.textContent     = 'Sold Out';
        qaCheckout.textContent = 'Sold Out';
      }
    }

    qaOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    // Focus trap for accessibility
    setTimeout(function() { qaClose && qaClose.focus(); }, 50);
  }

  function closeQuickAdd() {
    qaOverlay.classList.remove('open');
    document.body.style.overflow = '';
    selectedVariantId = null;
  }

  // ── EVENT DELEGATION — catches ALL .dz-quick-add-btn on the page,
  //    including those in sections rendered after DOM ready ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.dz-quick-add-btn');
    if (btn && !btn.disabled) {
      e.preventDefault();
      openQuickAdd(btn);
    }
  });

  // ── Touch: prevent ghost clicks on mobile ──
  document.addEventListener('touchend', function(e) {
    var btn = e.target.closest('.dz-quick-add-btn');
    if (btn && !btn.disabled) {
      e.preventDefault();
      openQuickAdd(btn);
    }
  }, { passive: false });

  // ── Close triggers ──
  if (qaClose) qaClose.addEventListener('click', closeQuickAdd);
  qaOverlay.addEventListener('click', function(e) {
    if (e.target === qaOverlay) closeQuickAdd();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && qaOverlay.classList.contains('open')) closeQuickAdd();
  });

  // ── Checkout Now ──
  qaCheckout.addEventListener('click', function() {
    if (!selectedVariantId) return;
    window.location.href = '/checkout?checkout[line_items][0][variant_id]='
      + selectedVariantId + '&checkout[line_items][0][quantity]=1';
  });

  // ── Add to Cart ──
  qaCart.addEventListener('click', function() {
    if (!selectedVariantId) return;
    var origText = qaCart.textContent;
    qaCart.disabled = true;
    qaCart.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariantId, quantity: 1 }] })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        // error from Shopify
        qaCart.textContent = data.description || 'Error';
        qaCart.disabled = false;
        return;
      }
      // Update cart count in header
      return fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          document.querySelectorAll('.cart-pill').forEach(function(el) {
            el.textContent = cart.item_count;
          });
          qaCart.textContent = 'Added!';
          setTimeout(function() {
            closeQuickAdd();
            qaCart.textContent = origText;
            qaCart.disabled = false;
          }, 700);
        });
    })
    .catch(function() {
      qaCart.textContent = 'Error — try again';
      qaCart.disabled = false;
    });
  });

})();

/* ============================================
   BUY THE DROP — BUNDLE MODAL
   ============================================ */
(function() {
  var bdOverlay  = document.getElementById('bd-overlay');
  var bdClose    = document.getElementById('bd-close');
  var bdCheckout = document.getElementById('bd-checkout-btn');
  var bdTrigger  = document.getElementById('dz-bundle-trigger');

  if (!bdOverlay) return;

  // Track selections: { productId: variantId }
  var selections = {};

  // Pre-select single-variant products
  document.querySelectorAll('.bd-variant-input').forEach(function(input) {
    selections[input.dataset.product] = input.value;
  });

  function checkAllSelected() {
    // Every bd-row needs a selection
    var rows = document.querySelectorAll('#bd-products .bd-row');
    var allDone = true;
    rows.forEach(function(row) {
      var pid = row.dataset.productId;
      if (!selections[pid]) allDone = false;
    });
    if (bdCheckout) {
      bdCheckout.disabled = !allDone;
      bdCheckout.textContent = allDone ? 'Checkout — Buy The Drop' : 'Complete Selections to Checkout';
    }
  }
  checkAllSelected();

  // Option buttons inside bundle modal
  document.querySelectorAll('.bd-opt-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var pid = btn.dataset.product;
      // deactivate siblings
      document.querySelectorAll('.bd-opt-btn[data-product="' + pid + '"]').forEach(function(b){ b.classList.remove('bd-opt-btn--active'); });
      btn.classList.add('bd-opt-btn--active');
      selections[pid] = btn.dataset.variant;
      checkAllSelected();
    });
  });

  function openBundle() {
    bdOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeBundle() {
    bdOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (bdTrigger) bdTrigger.addEventListener('click', openBundle);
  if (bdClose)   bdClose.addEventListener('click', closeBundle);
  bdOverlay.addEventListener('click', function(e){ if (e.target === bdOverlay) closeBundle(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && bdOverlay.classList.contains('open')) closeBundle(); });

  // Build multi-item checkout URL
  if (bdCheckout) {
    bdCheckout.addEventListener('click', function() {
      var variantIds = Object.values(selections).filter(Boolean);
      if (!variantIds.length) return;
      // Shopify multi-item checkout URL format
      var params = variantIds.map(function(id, i) {
        return 'checkout[line_items][' + i + '][variant_id]=' + id + '&checkout[line_items][' + i + '][quantity]=1';
      }).join('&');
      window.location.href = '/checkout?' + params;
    });
  }
})();
